/** 收益明细 — visible history window (calendar months, inclusive). */
export const REVENUE_DETAILS_VISIBLE_MONTHS = 3;

export function currentMonthYyyyMm(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function earliestRevenueDetailsMonth(now = new Date()): string {
  const d = new Date(now.getFullYear(), now.getMonth() - (REVENUE_DETAILS_VISIBLE_MONTHS - 1), 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function earliestRevenueDetailsDate(now = new Date()): string {
  return `${earliestRevenueDetailsMonth(now)}-01`;
}

export function isRevenueDetailsMonthAllowed(month: string, now = new Date()): boolean {
  return month >= earliestRevenueDetailsMonth(now) && month <= currentMonthYyyyMm(now);
}

/** Accepts YYYY/MM/DD or YYYY-MM-DD. */
export function isRevenueDetailsWeekStartAllowed(start: string, now = new Date()): boolean {
  const dateOnly = start.trim().replace(/\//g, '-').slice(0, 10);
  return dateOnly >= earliestRevenueDetailsDate(now);
}
